import { PayExemptionCatalog } from '@/Domain/Entities';

export default class PayExemptionProcess {
    // CON-451: el descuento elegido se identifica por el Guid de ProcessConfigurationPayExemption,
    // no por el bit-flag. El backend lo emite y lo espera en `payExemption.payExemptionType`.
    private _payExemptionType: string | null;
    private _autonomousCommunity: number | null;
    private _catalog: PayExemptionCatalog;

    public constructor(data: any, processConfigurationPayExemptions?: any[]) {
        this._payExemptionType = data.payExemptionType || null;
        this._autonomousCommunity = data.autonomousCommunity;
        this._catalog = new PayExemptionCatalog(processConfigurationPayExemptions);
    }

    public get payExemptionType() {
        return this._payExemptionType;
    }

    public set payExemptionType(newPayExemptionType: string | null) {
        this._payExemptionType = newPayExemptionType;
    }

    public get autonomousCommunity() {
        return this._autonomousCommunity;
    }

    public set autonomousCommunity(newAutonomousCommunity: number | null) {
        this._autonomousCommunity = newAutonomousCommunity;
    }

    public get catalog(): PayExemptionCatalog {
        return this._catalog;
    }

    public get isExceptionPaymentFamily() {
        return this._catalog.isLargeFamily(this._payExemptionType);
    }

    public get isDisability() {
        return this._catalog.isDisability(this._payExemptionType);
    }

    /** Ni "no configurado" ni "sin motivo": el candidato pidió un descuento real. */
    public get hasRealPayExemption() {
        return this._payExemptionType !== null && !this._catalog.isNoneOrNoReason(this._payExemptionType);
    }

    public get isNoReason() {
        return this._catalog.isNoReason(this._payExemptionType);
    }

    public autonomousCommunityVissible() {
        if (!this.isExceptionPaymentFamily) {
            this.autonomousCommunity = null;
        }
        return this.isExceptionPaymentFamily;
    }

    public toServer(inscriptionId, myAutonomousCommunity) {
        return {
            inscriptionId,
            payExemptionType: this._payExemptionType,
            autonomousCommunity: myAutonomousCommunity
        };
    }

    public toServerInscription() {
        return {
            payExemptionType: this._payExemptionType,
            autonomousCommunity: this.isExceptionPaymentFamily ? this._autonomousCommunity : null
        };
    }
}
